import Validation from "./Validation";
import primaryComponents from "../../primaryComponents";
import styles from "./styles.module.scss";
import useBankAccountLogic from "./useBankAccountLogic";
import { convertToTilteCase } from "../../../helpers";

const AddBankAccount = ({
  bankInfo,
  isEditMode = false,
  handleFetchAccountsList = () => {},
  closeWidget = () => {},
}) => {
  const {
    bankDetails,
    bankAccountTypes,
    setBankDetails,
    handleAddBank,
    handleEditBank,
    updateBankAccountMutation,
    createBankAccountMutation,
  } = useBankAccountLogic({
    closeWidget,
    bankInfo,
    handleFetchAccountsList,
  });
  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = Validation({ bankDetails });
  return (
    <div className={styles.allAccounting}>
      <div className="">
        <div className={styles.formSection}>
          <div className={`w-100 cover ${styles.formFieldRow}`}>
            <primaryComponents.InputFieldV2
              control={control}
              isRequired={true}
              classNames="white"
              name="accountName"
              label="Account Name"
              placeholder="Enter account name"
              value={bankDetails?.account_name}
              onChange={({ target: { value } }) => {
                setBankDetails((prev) => ({
                  ...prev,
                  account_name: value,
                }));
              }}
              errorMessage={errors.accountName}
              onKeyUp={() =>
                errors.accountName !== undefined && trigger("accountName")
              }
              register={register}
            />
            <primaryComponents.InputFieldV2
              control={control}
              name="bankName"
              label={"Bank Name"}
              isRequired={true}
              placeholder="Enter bank name"
              value={bankDetails?.bank_name}
              onChange={({ target: { value } }) => {
                setBankDetails((prev) => ({
                  ...prev,
                  bank_name: value,
                }));
              }}
              classNames="white"
              register={register}
              onKeyUp={() =>
                errors.bankName !== undefined && trigger("bankName")
              }
              errorMessage={errors.bankName}
            />
          </div>
          <div className={`w-100 cover ${styles.formFieldRow}`}>
            <primaryComponents.InputFieldV2
              control={control}
              classNames="white"
              name="accountNumber"
              label="Account Number"
              placeholder="10 digit NUBAN"
              value={bankDetails?.account_number}
              onChange={({ target: { value } }) => {
                setBankDetails((prev) => ({
                  ...prev,
                  account_number: value,
                }));
              }}
              errorMessage={errors.accountNumber}
              onKeyUp={() =>
                errors.accountNumber !== undefined && trigger("accountNumber")
              }
              register={register}
            />
            <primaryComponents.SelectField
              control={control}
              classNames="white w-100"
              name="bankAccountType"
              label="Account Type"
              options={bankAccountTypes}
              nameKey="label"
              idKey="value"
              value={convertToTilteCase(bankDetails?.bank_account_type)}
              onChange={(value) => {
                setBankDetails((prev) => ({
                  ...prev,
                  bank_account_type: value,
                }));
              }}
              errorMessage={errors.bankAccountType}
              onKeyUp={() =>
                errors.accountNumber !== undefined && trigger("bankAccountType")
              }
              register={register}
            />
          </div>
          {!isEditMode && (
            <div className={`w-100 cover ${styles.formFieldRow}`}>
              <primaryComponents.AmountFieldV2
                control={control}
                classNames="white"
                name="openingBalance"
                label="Opening Balance"
                placeholder="Enter opening balance"
                value={bankDetails?.opening_balance}
                onChange={({ target: { value } }) => {
                  setBankDetails((prev) => ({
                    ...prev,
                    opening_balance: value,
                  }));
                }}
                errorMessage={errors.openingBalance}
                onKeyUp={() =>
                  errors.openingBalance !== undefined &&
                  trigger("openingBalance")
                }
                register={register}
              />
              <primaryComponents.DateInputV2
                control={control}
                classNames="white w-100"
                name="balanceDate"
                label="Balance Date"
                value={bankDetails?.balance_date}
                onChange={({ target: { value } }) => {
                  setBankDetails((prev) => ({
                    ...prev,
                    balance_date: value,
                  }));
                }}
                errorMessage={errors.balanceDate}
                onKeyUp={() =>
                  errors.balanceDate !== undefined && trigger("balanceDate")
                }
                register={register}
              />
            </div>
          )}
          <div className="w-100 cover">
            <primaryComponents.TextAreaV2
              control={control}
              label={
                <span>
                  Notes <span className="small">(Optional)</span>
                </span>
              }
              name="description"
              isRequired={false}
              type="text"
              placeholder="Add internal note about this account"
              value={bankDetails?.description}
              classNames="white"
              errorMessage={errors.description}
              onChange={({ target: { value } }) => {
                setBankDetails((prev) => ({
                  ...prev,
                  description: value,
                }));
              }}
              onKeyUp={() =>
                errors.description !== undefined && trigger("description")
              }
            />
          </div>
        </div>
      </div>

      {isEditMode ? (
        <primaryComponents.Button
          onClick={handleSubmit(handleEditBank)}
          classNames="btn btn--primary cover mt-auto"
          isDisabled={updateBankAccountMutation.isLoading}
          isLoading={updateBankAccountMutation.isLoading}
          loadingText={"Updating..."}
        >
          Update Account
        </primaryComponents.Button>
      ) : (
        <primaryComponents.Button
          onClick={handleSubmit(handleAddBank)}
          classNames="btn btn--primary cover mt-auto"
          isDisabled={createBankAccountMutation.isLoading}
          isLoading={createBankAccountMutation.isLoading}
          loadingText={"Adding..."}
        >
          Add Account
        </primaryComponents.Button>
      )}
    </div>
  );
};

export default AddBankAccount;
